import { invoicePaymentStatusMap, invoiceTypeToTooltip } from "./InvoicesDigestWIdget.utils";
import { NavLink } from 'react-router-dom';
import styles from "./InvoicesDigestWidget.module.scss";
import { FullRow, Tooltip } from 'seagull';
import pluralize from "../../../utils/pluralize";
import { routes } from "../../../constants";
import { invoiceStatusToColor } from "./InvoicesDigestWidget";
import { utils } from "../../../utils";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const InvoiceBar = _ref => {
  let {
    invoicesDigest
  } = _ref;
  const paymentStatus = 'paymentStatus';
  return /*#__PURE__*/_jsx(FullRow, {
    className: styles.invoiceBarContent,
    "data-testid": "invoices-bar",
    children: invoicesDigest.percentages().map(_ref2 => {
      let {
        type,
        percentage,
        count,
        amount
      } = _ref2;
      return /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsxs("div", {
          "data-testid": "invoice-bar-".concat(type, "-percentage-tooltip"),
          children: [utils.formatNumberWithCommas(count), " ", pluralize('invoice', count), " totaling", ' ', amount.display(), " ", invoiceTypeToTooltip(count)[type]]
        }),
        children: /*#__PURE__*/_jsx(NavLink, {
          style: {
            width: "".concat(percentage, "%"),
            backgroundColor: invoiceStatusToColor[type]
          },
          to: "".concat(routes.invoicesDashboard, "?").concat(paymentStatus, "=").concat(invoicePaymentStatusMap[type]),
          "data-testid": "invoice-bar-".concat(type, "-percentage"),
          className: styles.invoiceBarPercentage
        })
      }, type);
    })
  });
};
export default InvoiceBar;